import { ServicePageTemplate } from "./ServicePageTemplate";
import { getServiceBySlug } from "@/data/services";

const DeepTissueMassage = () => (
  <ServicePageTemplate service={getServiceBySlug("deep-tissue-massage")} />
);

export default DeepTissueMassage;
